import {getContactInfo} from "../../api/mainpage/ContactInfo";
import {getMessage, postReply} from "../../api/contacts"

const state = () => ({

  ContactInfo:{},
  newsId: null,
  contactMessage: null
})


const getters = {
  get_ContactInfo(state) {
    return state.ContactInfo;
  },
  get_contactMessage(state) {
    return state.contactMessage;
  }
}

const mutations = {
  SET_CONTACTINF(state,data){
    state.ContactInfo = data;},
  SET_CONTACTMESSAGE(state, data){
    state.contactMessage = data;
  }
}

const actions = {
  async fetchContactInfo({ commit }) {
    try {
      const response = await getContactInfo();
      commit('SET_CONTACTINF', response.data);
    } catch (error) {
      // handle the error here
    }
  },
  async fetchContactMessage ({commit} , payload) {
    try {
      const res = await getMessage (payload.page , payload.pageSize);
      commit('SET_CONTACTMESSAGE', res);
    }
    catch(e) {
      // console.log('خطا در feetch', e);
    }
  },
  async postReplyAction ({commit}, payload){
    try {
      await postReply(payload);
    }
    catch (e){
      // console.log(e);
    }
  }

}




export  default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
